import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { PersonaService } from "src/app/servicios/persona.service";
import { MatDialog } from "@angular/material/dialog";

import { Subject } from "rxjs";
import { DataTableDirective } from "angular-datatables";

import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { HelperService } from "src/app/servicios/helper.service";
import * as _moment from "moment";
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
} from "@angular/material/core";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { Utils } from "../../utils/utils";
import { UsuarioService } from "../../servicios/usuario.service";
import { EntregaService } from "../../servicios/entrega.service";
import { AgenciaService } from "../../servicios/agencia.service";
import { DialogDocumentoComponent } from "../../dialogs/dialog-documento/dialog-documento.component";
import { DialogWebServiceComponent } from "../../dialogs/dialog-web-service/dialog-web-service.component";

declare let $: any;

export const MY_FORMATS = {
  parse: {
    dateInput: "YYYY-MM-DD",
  },
  display: {
    dateInput: "YYYY-MM-DD",
    monthYearLabel: "YYYY-MM-DD",
    dateA11yLabel: "YYYY-MM-DD",
    monthYearA11yLabel: "YYYY-MM-DD",
  },
};

export interface Usuario {
  id: string;
  valor: string;
}

@Component({
  selector: "app-entregas",
  templateUrl: "./entregas.component.html",
  styleUrls: ["./entregas.component.css"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class EntregasComponent implements OnInit {
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  //dtOptions: any = {};
  dataEntregas = [];
  haveData = false;
  loading = false;
  timeRunning = 0;
  usuarios: Usuario[];
  filteredUsuarios: Observable<Usuario[]>;
  agencias: any[] = [];
  usuarioConsulta = "";
  loadingAgencias = false;
  loadingUsuarios = false;

  dtTrigger = new Subject();

  entregasGroup: FormGroup;

  tipoConsultaSrv = [
    {
      id: 1,
      value: "Fecha Servicio",
    },
    {
      id: 2,
      value: "Fecha Creación",
    },
  ];

  dtOptions: any = {
    pagingType: "full_numbers",
    scrollX: true,
    dom: "Bfrtip",
    buttons: [
      "colvis",
      {
        extend: "copyHtml5",

        exportOptions: {
          columns: ":visible",
        },
      },
      {
        extend: "excelHtml5",
        fileName: "CustomFileName" + ".xlsx",
        exportOptions: {
          columns: ":visible",
        },
        //CharSet: "utf8",
        exportData: { decodeEntities: true },
      },
    ],
  };

  constructor(
    private formBuilder: FormBuilder,
    private servicePersona: PersonaService,
    private serviceUsuario: UsuarioService,
    private serviceEntrega: EntregaService,
    private servicioAgencia: AgenciaService,
    private dialog: MatDialog,
    private helper: HelperService,
    public ruta: Utils
  ) {
    const fechaHoy = new Date();
    const nFecha = _moment(fechaHoy, "YYYY-MM-DD").format("YYYY-MM-DD");
    this.entregasGroup = this.formBuilder.group({
      idAgencia: ["", Validators.required],
      usuarioCtrl: ["", Validators.required],
      fechaInicial: [new Date(), Validators.required],
      fechaFinal: [new Date(), Validators.required],
      tipoConsulta: [1, Validators.required],
    });

    const infoUsuario = JSON.parse(sessionStorage.getItem("infoUsuario"));
    this.usuarioConsulta = infoUsuario[0].IdUsuario;
    this.loadingAgencias = true;
    this.servicioAgencia
      .getAgencia(infoUsuario[0].IdUsuario, 0)
      .subscribe((result) => {
        this.agencias = result;
        this.agencias.unshift({
          id: "0",
          valor: "TODOS",
        });
        this.entregasGroup.controls["idAgencia"].setValue("0");
        this.loadingAgencias = false;
        this.entregasGroup.get("idAgencia").valueChanges.subscribe((value) => {
          this.cargarUsuariosAgencia();
        });
        //console.log(this.agencias);
      });

    this.loadingUsuarios = true;
    this.serviceUsuario
      .getUsuariosPersonas(2, infoUsuario[0].IdUsuario, 0, 0)
      .subscribe((result) => {
        this.usuarios = result;
        this.usuarios.unshift({
          id: "0",
          valor: "TODOS",
        });
        this.entregasGroup.controls["usuarioCtrl"].setValue({
          id: "0",
          valor: "TODOS",
        });
        this.loadingUsuarios = false;
        this.filteredUsuarios = this.entregasGroup
          .get("usuarioCtrl")
          .valueChanges.pipe(
            startWith(""),
            map((usuario) =>
              usuario ? this._filterUsuarios(usuario) : this.usuarios.slice()
            )
          );
      });

    this.cargarInformacion(0, this.usuarioConsulta, 0, nFecha, nFecha, 1);
  }

  ngOnInit() {
    this.ruta.setRuta();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  displayFn(usuario) {
    //console.log(JSON.stringify(usuario));
    return usuario ? usuario.valor : usuario;
  }

  private _filterUsuarios(value: any): Usuario[] {
    let filterValue: any;
    if (typeof value === "object") {
      filterValue = value.valor.toLowerCase();
    } else {
      filterValue = value.toLowerCase();
    }
    console.log(filterValue);
    //const filterValue = value.valor.toLowerCase();

    return this.usuarios.filter(
      (usuario) => usuario.valor.toLowerCase().indexOf(filterValue) > -1
    );
  }

  busqueda() {
    //console.log(this.entregasGroup.get('idAgencia').value);
    //return;
    const usuarioConsulta = this.usuarioConsulta;
    const agencia = this.entregasGroup.get("idAgencia").value;
    const usuario = this.entregasGroup.get("usuarioCtrl").value;
    const fechaInicial = _moment(
      this.entregasGroup.get("fechaInicial").value,
      "YYYY-MM-DD"
    ).format("YYYY-MM-DD");
    const fechaFinal = _moment(
      this.entregasGroup.get("fechaFinal").value,
      "YYYY-MM-DD"
    ).format("YYYY-MM-DD");
    const tipoConsulta = this.entregasGroup.get("tipoConsulta").value;
    //console.log(tipoConsulta);
    //return;
    this.cargarInformacion(
      agencia,
      usuarioConsulta,
      usuario.id,
      fechaInicial,
      fechaFinal,
      tipoConsulta
    );
  }

  cargarInformacion(
    agencia,
    usuarioConsulta,
    usuario,
    fechaInicial,
    fechaFinal,
    tipoConsulta
  ) {
    this.loading = true;
    this.serviceEntrega
      .getInformeEntregas(
        agencia,
        usuarioConsulta,
        usuario,
        fechaInicial,
        fechaFinal,
        tipoConsulta
      )
      .subscribe((data) => {
        this.dataEntregas = data;
        this.loading = false;
        if (data.length > 0) {
          this.haveData = true;
        }

        if (this.timeRunning == 0) {
          this.dtTrigger.next();
        } else {
          this.reRender();
        }
        this.timeRunning++;
      });
  }

  cargarUsuariosAgencia() {
    this.loadingUsuarios = true;
    const agencia = this.entregasGroup.get("idAgencia").value;

    this.serviceUsuario
      .getUsuariosPersonas(2, this.usuarioConsulta, agencia, 0)
      .subscribe((result) => {
        this.usuarios = result;
        this.usuarios.unshift({
          id: "0",
          valor: "TODOS",
        });
        this.entregasGroup.controls["usuarioCtrl"].setValue({
          id: "0",
          valor: "TODOS",
        });
        this.loadingUsuarios = false;
        this.filteredUsuarios = this.entregasGroup
          .get("usuarioCtrl")
          .valueChanges.pipe(
            startWith(""),
            map((usuario) =>
              usuario ? this._filterUsuarios(usuario) : this.usuarios.slice()
            )
          );
      });
  }

  reRender() {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again

      this.dtTrigger.next();
    });
  }

  refrescaBusqueda() {
    const busqueda = this.entregasGroup.controls["persona"].value;
    this.dtOptions = {
      pagingType: "full_numbers",
      dom: "Bfrtip",
      buttons: ["copy", "csv", "excel", "pdf", "print"],
    };
    this.loading = true;
    this.servicePersona.getBusquedaPersona(busqueda).subscribe((data) => {
      this.dataEntregas = data;
      this.loading = false;
      if (data.length > 0) {
        this.haveData = true;
      }

      if (this.timeRunning == 0) {
        this.dtTrigger.next();
      } else {
        this.reRender();
      }
      this.timeRunning++;
    });
  }

  verDocumento(ordenSAP, idServicio, tipoImagen) {
    const params = {
      ordenSAP: ordenSAP,
      idServicio: idServicio,
      tipoImagen: tipoImagen,
    };
    const dialogRef = this.dialog.open(DialogDocumentoComponent, {
      data: params,
      width: "100em",
      //disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      /*if (result) {
        this.refrescaBusqueda();
      }*/
      console.log("Resultado es :" + result);
    });
  }

  verDetalleWS(idTipoWS, idPaquete) {
    const params = {
      idTipoWS: idTipoWS,
      idPaquete: idPaquete,
    };
    const dialogRef = this.dialog.open(DialogWebServiceComponent, {
      data: params,
      width: "100em",
      //disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      /*if (result) {
        this.refrescaBusqueda();
      }*/
      console.log("Resultado es :" + result);
    });
  }
}
